// Derives a snake_case dataset identifier from a human-friendly name.
// The result must stay within the character set MDH accepts for the dataset name
// (used directly in the API path / as a MongoDB collection name), so we restrict
// it to [a-z0-9_].
export const generateDatasetName = (name: string) => {
  return name
    .toLowerCase()
    .normalize('NFD') // Decompose accented characters
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritical marks
    .replace(/[^a-z0-9\s_]/g, '') // Remove invalid characters
    .replace(/[\s_]+/g, '_') // Collapse whitespace and underscores into a single underscore
    .replace(/^_+|_+$/g, ''); // Trim underscores from start/end
};

// Matches identifiers produced by `generateDatasetName`: lowercase snake_case
// with no leading/trailing/double underscores.
export const datasetNamePattern = /^[a-z0-9]+(?:_[a-z0-9]+)*$/;
